// extracted by css-extract-rspack-plugin
export default {"listNone":"_b0765807","chevronOpen":"_6c27ddf0"};